module.exports = __webpack_public_path__ + "static/media/gm.f26ded8d.png";